import EstablishmentChoiceEntryAuctionEntryCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/EstablishmentChoiceEntryFormStep/AuctionEntry/EstablishmentChoiceEntryAuctionEntryCompleted'
import EstablishmentChoiceEntryAuctionEntryPending from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/EstablishmentChoiceEntryFormStep/AuctionEntry/EstablishmentChoiceEntryAuctionEntryPending'
import EstablishmentChoiceEntryManualEntryCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/EstablishmentChoiceEntryFormStep/ManualEntry/EstablishmentChoiceEntryManualEntryCompleted'
import EstablishmentChoiceEntryManualEntryPending from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/EstablishmentChoiceEntryFormStep/ManualEntry/EstablishmentChoiceEntryManualEntryPending'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { MaintenanceForwardingsEstablishmentChoiceEntryStepOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'

export const establishmentChoiceEntryOptions: {
  // Not every establishment-choice kind is creatable through this forwarding form (e.g. AuctionEntry
  // is only a discriminator on existing forwardings), so the map is keyed partially and consumers
  // filter by presence before rendering an option.
  [K in MaintenanceForwardingsEstablishmentChoiceEntryStepOptions]?: {
    title: string
    description: (directiveEntryType?: string) => string | undefined
    components: {
      pending: React.ComponentType
      completed: React.ComponentType
    }
  }
} = {
  [MaintenanceForwardingsEstablishmentChoiceEntryStepOptions.ManualEntry]: {
    title: 'Enviar para um único estabelecimento',
    description: (directiveEntryType) =>
      directiveEntryType === MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry
        ? 'Defina um estabelecimento para aceitar realizar a execução do serviço (apenas estabelecimentos homologados para seu Equipamento)'
        : 'Defina um estabelecimento para aceitar realizar o diagnóstico e orçamento (apenas estabelecimentos homologados para seu Equipamento)',
    components: {
      pending: EstablishmentChoiceEntryManualEntryPending,
      completed: EstablishmentChoiceEntryManualEntryCompleted,
    },
  },
  [MaintenanceForwardingsEstablishmentChoiceEntryStepOptions.AuctionEntry]: {
    title: 'Leilão para escolher estabelecimento',
    description: () =>
      'Defina quais estabelecimentos estarão aptos para visualizar e enviar lances (apenas estabelecimentos homologados para seu Equipamento)',
    components: {
      pending: EstablishmentChoiceEntryAuctionEntryPending,
      completed: EstablishmentChoiceEntryAuctionEntryCompleted,
    },
  },
}
